module.exports = __webpack_public_path__ + "media/control_acceso/puerta_automatica_labeled-ee22c4e5.png";